module.exports = __webpack_public_path__ + "static/img/45.90d3ea0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/scene/45.jpg
// module id = +maX
// module chunks = 3